const mockIsLoggedIn = true;

export default function getLandingPageData() {
  let loggedInResp = {
    success: true,
    givingLandingPageEnabled: true,
    network: {
      ID: 2,
      name: "Presentation of the Lord Catholic Church",
      shortname: "testnet",
      city: "Sciota",
      state: "PA",
      iconURL:
        "https://s3-us-west-2.amazonaws.com/dev-photos.flocknote.com/everyone/icon.png",
      website: "https://presentation.church",
    },
    user: {
      id: 149,
      firstName: "Mock",
      lastName: "Fostermock",
      isHoHOrSpouseOfHoH: true,
      householdSize: 3,
    },
    funds: [
      {
        ID: 1,
        description: "General Fund",
        details: "",
        fundColor: "9c47fc",
        paymentType: "Donation",
        allowRecurringGifts: false,
      },
      {
        ID: 3,
        description: "Youth Missions",
        details: "",
        fundColor: "FEC524",
        paymentType: "Donation",
        allowRecurringGifts: true,
      },
      {
        ID: 4,
        description: "Signup Fund - Paid Event",
        details: "",
        fundColor: "FAD755",
        paymentType: "Payment",
        allowRecurringGifts: true,
      },
      {
        ID: 5,
        description: "Signup Fund - Allentown Testing",
        details: "",
        fundColor: "828C8D",
        paymentType: "Payment",
        allowRecurringGifts: true,
      },
      {
        ID: 6,
        description: "Signup Fund - Paid Event 2",
        details: "",
        fundColor: "fd8a7d",
        paymentType: "Payment",
        allowRecurringGifts: true,
      },
      {
        ID: 7,
        description: "Signup Fund - Paid Event 3",
        details: "",
        fundColor: "fd8a7d",
        paymentType: "Payment",
        allowRecurringGifts: true,
      },
      {
        ID: 8,
        description: "Signup Fund - Paid Event 4",
        details: "",
        fundColor: "fd8a7d",
        paymentType: "Payment",
        allowRecurringGifts: true,
      },
      {
        ID: 9,
        description: "Signup Fund - Paid Event 5",
        details: "",
        fundColor: "fd8a7d",
        paymentType: "Payment",
        allowRecurringGifts: true,
      },
      {
        ID: 10,
        description: "Signup Fund - Paid Event 6",
        details: "",
        fundColor: "fd8a7d",
        paymentType: "Payment",
        allowRecurringGifts: true,
      },
    ],
    pageSettings: {
      // colorScheme: ["2A6984", "426E96", "6371A3"], // blue "dark" theme
      // colorScheme: ["ffc4ab", "ffc4ab", "fb8d76"], // light theme
      colorScheme: ["F2ECE3", "cbc2ac"], //MW
      accentColor: "3e3836",
      description:
        "Your financial gifts are critical as we work to transform our 23 acre property into a place where the Lord is rightly and fittingly worshipped, and where his people can gather for fellowship. Going forward, this page will serve as one, easy place to view your past gifts, manage recurring gifts and pledges, and make new donations. Thank you for your generosity and commitment to our parish.",
      // videoURL: "https://www.youtube.com/embed/i81s9t8fH5o?si=PA6H2wE3wA4rB7fy",
      imageURL:
        "https://d6iyrqjd26xke.cloudfront.net/chapelexpansionfrontview3/full.jpg", //optional
      showYearToDate: true,
      helpEmail: "admin@mychurch.com",
    },
    pledgeableCampaigns: [
      { ID: 1, title: "Building Fund Campaign", fundID: 1 },
      { ID: 2, title: "Youth Mission Trip Campaign", fundID: 4 },
    ],
    givingStats: {
      yearToDate: "$12399.56",
      nextPayments: [
        {
          ID: 1,
          date: 1698777261,
          fundName: "General Fund",
          amount: "120.00",
          recurringGiftID: 4,
          paymentMethod: {
            ID: 2,
            paymentType: "credit_card",
            cardType: "Visa",
            nickname: "",
            last4: "4242",
            expirationMonth: 12,
            expirationYear: 24,
          },
        },
        {
          ID: 2,
          date: 1698777261,
          fundName: "Building Fund",
          amount: "300.00",
          recurringGiftID: 4,
          paymentMethod: {
            ID: 2,
            paymentType: "credit_card",
            cardType: "Visa",
            nickname: "whatup",
            last4: "4242",
            expirationMonth: 12,
            expirationYear: 24,
          },
        },
      ],
      remainingThisMonth: "260.53",
    },
    callToActions: [
      {
        ID: 1,
        type: "GiveToFund",
        colorScheme: ["2A6984", "426E96", "6371A3"], //by default, pull from fund settings, but can be overriden by cta settings
        fundID: 123,
        fundName: "Building Fund",
        fundVerbiage: "give", //give/pay/donate (whatever we already send back in other scenarios)
        title: "Give to Building Fund", //optional
        description: "Help us raise money for the building fund.", //optional
        imageURL:
          "https://media.istockphoto.com/id/147712110/photo/church-with-symmetrical-design.jpg?s=612x612&w=0&k=20&c=e40FAFyJWRG46U4j4sxEi1iQnTzOhxKy1qenCUGFnjo=", //optional
        //action: "Give Now", //optional
        icon: "donate fas", //optional
        //backend note - this should not be returned if the fund is deleted or doesn't have a public giving page enabled
      },
      {
        ID: 2,
        type: "Message",
        colorScheme: ["2A6984", "426E96", "6371A3"],
        title: "Don't forget about the Thanksgiving pot luck!",
        description:
          "Bring your favorite dish - there will be a contest and prizes!.", //optional
        icon: "turkey fas", //optional
        //imageURL: "", //optional
        //url: "https://apple.com" //optional
        //action: "Go to link" //optional if they provide a url, ignored if they don't
      },
      {
        ID: 3,
        type: "Pledge",
        colorScheme: ["2A6984", "426E96", "6371A3"], //by default, pull from fund settings that the campaign is attached to, but can be overriden by cta settings
        campaignID: 123,
        campaignTitle: "Angel Tree",
        title: "Make a pledge!", //optional
        description:
          "More people are in need this holiday than they were last year.  Help out here.", //optional
        action: "Make a pledge", //optional
        icon: "tree-christmas fas", //optional
        imageURL: "", //optional
        suggestedAmount: 50, //optional
        userPledgeInfo: {
          //only return this if they have a pledge associated with this campaign
          pledgeID: 123,
          amount: 50,
          schedule: "weekly",
          nextGiftDate: "YYYY-MM-DD",
        },
        //backend notes
        // - this should not be returned if pledging is closed/not available (also if campaign is deleted, if the fund is deleted, or doesn't have a public giving page enabled)
        // - there should be a backend setting that does not return this CTA if the user already has a pledge goign
      },
      {
        ID: 4,
        type: "RecurringGift",
        colorScheme: ["2A6984", "426E96", "6371A3"],
        fundID: 123,
        fundName: "General Offeratory",
        title: "Make a recurring gift!", //optional
        description:
          "More people are in need this holiday than they were last year.  Help out here.", //optional
        action: "Setup a recurring gift", //optional
        icon: "tree-christmas fas", //optional
        imageURL: "", //optional
        suggestedAmount: 50, //optional
        suggestedSchedule: "monthly", //optional (monthly/weekly/whatever we normally can return here)
        userGiftInfo: {
          //only return this if they have a recurring gift active on this fund
          recurringGiftID: 123,
          amount: 50,
          schedule: "weekly",
          nextGiftDate: "YYYY-MM-DD",
        },
        //backend note - this should not be returned if the fund is deleted, doesn't have a public giving page enabled, or the fund doesn't have recurring gifts enabled on it
        //backend note - there should be a backend setting that does not return this CTA if the user already has a pledge goign
      },
      // {
      //   ID: 5,
      //   type: "CampaignStatus",
      //   colorScheme: ["2A6984", "426E96", "6371A3"],
      //   campaignID: 123,
      //   campaignTitle: "Angel Tree",
      //   title: "Let's hit our goal", //optional
      //   description:
      //     "More people are in need this holiday than they were last year.  Help out here.", //optional
      //   action: "Make a pledge", //optional
      //   icon: "tree-christmas fas", //optional
      //   imageURL: "", //optional

      //   totalRaised: 123,
      //   totalPledged: 456, //only return if the campaign has pledging enabled
      //   campaignGoal: 1000000, //only return if the campaign has a goal
      //   userCanGive: true, //usually true, but false if the fund does not have a public giving page
      //   suggestedAmount: 50, //optional
      //   pledgingOpen: true,
      //   userPledgeInfo: {
      //     //only return this if they have a pledge associated with this campaign
      //     pledgeID: 123,
      //     amount: 50,
      //     schedule: "weekly",
      //     nextGiftDate: "YYYY-MM-DD",
      //   },
      //   userGiftInfo: {
      //     //only return this if they have a recurring gift active for this campaign
      //     recurringGiftID: 123,
      //     amount: 50,
      //     schedule: "weekly",
      //     nextGiftDate: "YYYY-MM-DD",
      //   },
      //   //backend note - this should not be returned if the campaign or fund is deleted
      // },
      {
        ID: 1619875756,
        type: 5,
        title: "Capital Fund",
        description:
          "This determines how quickly we can develop our parish campus. We are in great need of new buildings, classrooms, pathways, outdoor communal areas, and more.",
        imageURL: null,
        action: null,
        icon: "drafting-compass fas",
        fundID: 3106,
        colorScheme: ["486971", "2F4858"],
        fundName: "Phase One",
        fundVerbiage: "Donation",
        totalRaised: 1735284.91,
        totalPledged: 398360.11,
        campaignGoal: "1000000.00",
        userCanGive: true,
        suggestedAmount: 50,
        pledgingOpen: true,
        userPledgeInfo: {
          pledgeID: 252,
          amount: "75.00",
          schedule: "Monthly",
          nextGiftDate: "2023-11-25",
        },
        userGiftInfo: {
          recurringGiftID: 1417,
          amount: 7500,
          schedule: "Monthly",
          nextGiftDate: "2023-11-25",
        },
      },
    ],
    isApp: false,
    userID: 11,
  };

  let notLoggedInResp = {
    success: true,
    givingLandingPageEnabled: true,
    network: {
      ID: 2,
      name: "MarkTest TestNet",
      shortname: "testnet",
      city: "Sciota",
      state: "PA",
      iconURL:
        "https://s3-us-west-2.amazonaws.com/dev-photos.flocknote.com/everyone/icon.png",
      website: null,
      colorScheme: ["F2ECE3", "cbc2ac"], //MW
    },
    user: {},
    funds: [
      {
        ID: 1,
        description: "General Fund",
        details: "",
        fundColor: "9c47fc",
        paymentType: "Donation",
      },
      {
        ID: 3,
        description: "Youth Missions",
        details: "",
        fundColor: "FEC524",
        paymentType: "Donation",
      },
      {
        ID: 4,
        description: "Signup Fund - Paid Event",
        details: "",
        fundColor: "FAD755",
        paymentType: "Payment",
      },
      {
        ID: 5,
        description: "Signup Fund - Allentown Testing",
        details: "",
        fundColor: "828C8D",
        paymentType: "Payment",
      },
      {
        ID: 6,
        description: "Signup Fund - Paid Event 2",
        details: "",
        fundColor: "fd8a7d",
        paymentType: "Payment",
      },
    ],
    pageSettings: {
      // colorScheme: ["2A6984", "426E96", "6371A3"], // blue "dark" theme
      // colorScheme: ["ffc4ab", "ffc4ab", "fb8d76"], // light theme
      colorScheme: ["F2ECE3", "cbc2ac"], //MW
      accentColor: "3e3836",
      description:
        "Your financial gifts are critical as we work to transform our 23 acre property into a place where the Lord is rightly and fittingly worshipped, and where his people can gather for fellowship. Going forward, this page will serve as one, easy place to view your past gifts, manage recurring gifts and pledges, and make new donations. Thank you for your generosity and commitment to our parish.",
      // videoURL: "https://www.youtube.com/embed/i81s9t8fH5o?si=PA6H2wE3wA4rB7fy",
      imageURL:
        "https://d6iyrqjd26xke.cloudfront.net/chapelexpansionfrontview3/full.jpg", //optional
      showYearToDate: true,
      helpEmail: "admin@mychurch.com",
    },
    givingStats: {},
    callToActions: loggedInResp.callToActions, //same structure as callToActions when logged in
    isApp: false,
  };

  return mockIsLoggedIn ? loggedInResp : notLoggedInResp;
}
